/* eslint-disable no-restricted-globals */

import { CHECK_EMAIL_REMINDER_PARAM } from "src/components/collapsible-header/CollapsibleHeader";
import { updateForwardedParams } from "src/utils/urlParams";
import { forwardUpid } from "./utils";
import getStore from "src/utils/redux/store";
import goto from ".";

export type OffersParams = {
  userId?: string;
  acceptedCoursePackOffer?: boolean;
};

export type CollapsibleHeaderUrlParams = {
  showEmailReminder?: "noomPremium" | "noomSummit" | false;
};

export default {
  noomPremium() {
    forwardUpid(getStore());

    goto.layer("noom-premium");
  },
  addOns({ showEmailReminder }: CollapsibleHeaderUrlParams) {
    updateForwardedParams({
      [CHECK_EMAIL_REMINDER_PARAM]: showEmailReminder ?? null,
    });
    forwardUpid(getStore());

    goto.layer("addons");
  },

  fastForwardTrial({ showEmailReminder }: CollapsibleHeaderUrlParams) {
    updateForwardedParams({
      [CHECK_EMAIL_REMINDER_PARAM]: showEmailReminder ?? null,
    });
    forwardUpid(getStore());

    goto.layer(`fast-forward`);
  },
};
